// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2d4dY","actions":"GroupTable_actions__X-oqj","deleteModalFooter":"GroupTable_deleteModalFooter__1qQaJ"};